export function isContentWriter(groups) {
  return groups.includes("Content Writer");
}
